export function loadPxCloudScript(
  key: string | undefined = import.meta.env.VITE_HUMAN_SECURITY_KEY,
): void {
  if (!key) {
    console.warn(
      '[px-cloud] Missing VITE_HUMAN_SECURITY_KEY; skipping script injection.',
    )
    return
  }

  const script = document.createElement('script')
  script.src = `https://client.px-cloud.net/${key}/main.min.js`
  script.async = true
  document.head.appendChild(script)
}
